import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import ActionTypes from '../constants/action-types';

import { RootActionTypes, ThunkResult } from '../../../stores/types';
import { ExportAccountForm, ExportResponseType } from '../types';
import formatErrorResponseV2, { FormattedErrorMessages } from '../../../utilities/format-error-response-v2';
import { LegacyResponse } from '../../../utilities/clients/types/server';
import toLegacyResponse from '../../../utilities/clients/to-legacy-response';

enum AccountTransactionsExportType {
  'TransactionExport' = 'account_transactions_export_type',
}

export function exportAccountTransactionsRequest(): RootActionTypes {
  return {
    type: ActionTypes.EXPORT_ACCOUNT_TRANSACTIONS_REQUEST,
  };
}

export function exportAccountTransactionsSuccess(
  accountExport: io.flow.v0.models.Export,
): RootActionTypes {
  return {
    type: ActionTypes.EXPORT_ACCOUNT_TRANSACTIONS_SUCCESS,
    payload: accountExport,
  };
}

export function exportAccountTransactionsFailure(
  error?: FormattedErrorMessages,
): RootActionTypes {
  return {
    type: ActionTypes.EXPORT_ACCOUNT_TRANSACTIONS_FAILURE,
    error: true,
    payload: error,
  };
}

export default function exportAccountOrders(form: ExportAccountForm):
ThunkResult<Promise<LegacyResponse<ExportResponseType>>> {
  return function exportAccountOrdersEffects(
    dispatch,
    getState,
    extra,
  ): Promise<LegacyResponse<ExportResponseType>> {
    dispatch(exportAccountTransactionsRequest());

    const mergedOptions = omitBy({
      created_from: form.createdFrom,
      created_to: form.createdTo,
      statement_id: form.statement,
      status: form.status,
    }, isNil);
    return extra.api(getState()).exports.post({
      organization: form.organization,
      body: {
        emails: form.emails,
        type: {
          discriminator: AccountTransactionsExportType.TransactionExport,
          ...mergedOptions,
        },
      },
    }).then((response) => {
      if (response.ok) {
        dispatch(exportAccountTransactionsSuccess(response.body));
      } else {
        dispatch(exportAccountTransactionsFailure(formatErrorResponseV2(response)));
      }

      return toLegacyResponse<ExportResponseType>(response);
    });
  };
}
